import { render, staticRenderFns } from "./VehicleGarageList.vue?vue&type=template&id=6ecae303&lang=pug"
import script from "./VehicleGarageList.vue?vue&type=script&lang=js"
export * from "./VehicleGarageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports